import styled from 'styled-components';

import { mediaQueryDesktopMin, mediaQueryLaptopMin } from 'styles/variables';

export const Wrapper = styled.footer`
  max-width: 100%;
  width: 100%;

  @media all and ${mediaQueryDesktopMin} {
    max-width: 742px;
  }

  @media all and ${mediaQueryLaptopMin} {
    margin-top: 16px;
    width: calc(100% - 325px);
  }
`;
